import React from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title,
} from "chart.js";
import { useSelector } from "react-redux";

ChartJS.register(
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title
);

const TdsLineChart = (
    {
        values = [10000, 10200, 10400, 10600, 10800, 11000, 11200, 11400],
        labels = ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov"],
        label = "TDS Deducted",
        pointStyle = "rect",
        legendPosition = "top",
    }
) => {
    const themeSstore = useSelector((state) => state.theme)
    const themeStyle = themeSstore.theme

    const data = {
        labels: labels,
        datasets: [
            {
                label: label,
                data: values,
                borderColor: "#7B61FF",
                backgroundColor: "#7B61FF",
                borderWidth: label ? 1 : 0,
                tension: 0,
                pointRadius: 4,
                pointBackgroundColor: label ? "#7B61FF" : "transparent",
                pointBorderColor: "#fff",
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: true, // 👈 FIXED (stop infinite resizing)
        aspectRatio: 1.6, // 👈 control chart proportions
        plugins: {
            legend: {
                position: legendPosition,
                labels: {
                    color: themeStyle == "dark" ? "#fff" : "#000",
                    usePointStyle: true,
                    pointStyle: pointStyle,
                    boxWidth: 18,
                    padding: 10,
                },
            },
            tooltip: {
                backgroundColor: themeStyle == "dark" ? "#1e1e2f" : "#fff",
                titleColor: themeStyle == "dark" ? "#fff" : "#000",
                bodyColor: themeStyle == "dark" ? "#ddd" : "#000",
                callbacks: {
                    label: (ctx) => `₹ ${ctx.parsed.y.toLocaleString()}`,
                },
            },
        },
        scales: {
            x: {
                ticks: { color: themeStyle == "dark" ? "#ccc" : "#000" },
                grid: { color: themeStyle == "dark" ? "rgba(255,255,255,0.06)" : "#000" },
            },
            y: {
                min: 10000,
                max: 11400,
                ticks: {
                    stepSize: 200,
                    color: themeStyle == "dark" ? "#ccc" : "#000",
                    callback: (val) => val,
                },
                grid: { color: themeStyle == "dark" ? "rgba(255,255,255,0.06)" : "#000" },
            },
        },
    };

    return (

        <Line data={data} options={options} />
    );
};

export default TdsLineChart;
